// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__b4cNy","author":"Table_author__1J5oM","authorImage":"Table_authorImage__1VKa6","unreadRow":"Table_unreadRow__sWWP4"};